const ACTIONS = {
    UPDATE_LODGING_CANCELLATION_POLICY: 'LODGING_CANCELLATION_POLICY/UPDATE'
};

const ACTION_CREATORS = {
    updateLodgingCancellationPolicy(lodgingCancellationPolicy) {
        return {
            type: ACTIONS.UPDATE_LODGING_CANCELLATION_POLICY,
            payload: {
                lodgingCancellationPolicy
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
